/** @format */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_SIADASH_BACKEND_URL || 'http://localhost:5000';

/**
 * Delete a policy by ID
 */
export const deletePolicy = async (policyId: string) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/api/insurance-policies/${policyId}`
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to delete policy');
  }
};
